import { questionConstants } from '../constants';
import { showToast } from '../services/toast';
import { questionService } from '../services';

export const questionActions = {
  fetchQuestionsList,
  createQuestion,
  updateQuestion,
  deleteQuestion,
  updateQuestionSequence
};

function fetchQuestionsList(gameid) {
  return dispatch => {
    dispatch(request());

    questionService.fetchQuestionsList(gameid)
      .then(
        response => {
          dispatch(success(response.data));
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: questionConstants.FETCH_QUESTIONS_REQUEST } }
  function success(questions) { return { type: questionConstants.FETCH_QUESTIONS_SUCCESS, questions } }
  function failure(error) { return { type: questionConstants.FETCH_QUESTIONS_FAILURE, error } }
}

function createQuestion(formData) {
  return dispatch => {
    dispatch(request());

    return questionService.createQuestion(formData)
      .then(
        response => {
          dispatch(success(response));
          showToast(response.responseMessage, 'success');
          return response; 
        },
        error => {
          dispatch(failure(error.toString()));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
          return Promise.reject(error);
        }
      );
  };

  function request() { return { type: questionConstants.CREATE_QUESTION_REQUEST } }
  function success(questions) { return { type: questionConstants.CREATE_QUESTION_SUCCESS, questions } }
  function failure(error) { return { type: questionConstants.CREATE_QUESTION_FAILURE, error } }
}

function updateQuestion(formData) {
  return dispatch => {
    dispatch(request());

    return questionService.updateQuestion(formData)
      .then(
        response => {
          dispatch(success(response.data));
          showToast(response.responseMessage, 'success');
          return response; 
        },
        error => {
          dispatch(failure(error.toString()));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
          return Promise.reject(error);
        }
      );
  };

  function request() { return { type: questionConstants.UPDATE_QUESTION_REQUEST } }
  function success(questions) { return { type: questionConstants.UPDATE_QUESTION_SUCCESS, questions } }
  function failure(error) { return { type: questionConstants.UPDATE_QUESTION_FAILURE, error } }
}

function deleteQuestion(gameId, QuestionId) {

  return dispatch => {
    dispatch(request());
    questionService.deleteQuestion(gameId, QuestionId)
      .then(
        (res) => {
          dispatch(success(QuestionId));
          showToast(res.responseMessage, 'success');
        },
        error => {
          dispatch(failure(error.toString()));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
        }
      );
  };

  function request() { return { type: questionConstants.DELETE_QUESTION_REQUEST } }
  function success(id) { return { type: questionConstants.DELETE_QUESTION_SUCCESS, payload: id } }
  function failure(error) { return { type: questionConstants.DELETE_QUESTION_FAILURE, error } }
}

function updateQuestionSequence(sequenceDetails) {
  return dispatch => {
    dispatch(request());

    return questionService.updateQuestionSequence(sequenceDetails)
      .then(
        response => {
          dispatch(success(response.data));
          return response;
        },
        error => {
          dispatch(failure(error.toString()));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
          return Promise.reject(error);
        }
      );
  };

  function request() { return { type: questionConstants.UPDATE_QUESTIONSEQUENCE_REQUEST } }
  function success(questions) { return { type: questionConstants.UPDATE_QUESTIONSEQUENCE_SUCCESS, questions } }
  function failure(error) { return { type: questionConstants.UPDATE_QUESTIONSEQUENCE_FAILURE, error } }
}
